













































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { ChannelGroup, ChannelGroupBehavior, ChannelGroupChannel, GroupSettings, PostTypeStyle, InteractionTypes, ChannelStyleTypes } from "@/services/channels/types";
import { getSetting, setSetting } from "@/services/autoSettings/autoSettingsService";
import { FormComponent, FormComponentModel } from "@/services/autoSettings/types";
import { getAllStyles } from "@/services/styles/stylesService";
import { ChannelStyle, Style } from "@/services/styles/types";
import { createChannelGroup, getChannelGroupById, updateChannelGroup } from "@/services/channels/channelGroupService";
import ChannelGroupSettings from "@/components/channels/ChannelGroupSettings.vue";
import ChannelGroupChannels from "@/components/channels/ChannelGroupChannels.vue";
import ChannelGroupPreviewModal from "@/components/channels/modals/ChannelGroupPreviewModal.vue";
import { validateForm } from "@/services/validation/validationService";
import HeaderActionButtons from "@/components/layouts/HeaderActionButtons.vue";
import UnsavedFormModal from "@/components/common/modals/UnsavedFormModal.vue";
import i18n from "@/i18n";
import { bus } from "@/bus";
import { getAllChannelStyles } from "@/services/styles/channelStylesService";

@Component<ChannelGroupForm>({
    beforeRouteLeave(to, from, next) {
        this.onBeforeRouteLeave(to, next);
    },
    components: {
        ChannelGroupSettings,
        ChannelGroupChannels,
        ChannelGroupPreviewModal,
        HeaderActionButtons,
        UnsavedFormModal
    }
})
export default class ChannelGroupForm extends Vue {
    @Prop() private channelGroupId!: string;
    @Prop() private folderId!: string;
    componentsData = [] as FormComponentModel[];
    formState = false;
    interactionTypes = InteractionTypes;

    channelGroup = {
        behavior: ChannelGroupBehavior.Sorted,
        folderId: this.folderId ? this.folderId : "",
        transitionType: "none",
        interactionType: this.interactionTypes.none,
        returnToFirstPostTime: 60,
        showFirstPost: true,
        transitionTime: 300,
        name: "",
        width: 0,
        height: 0,
        menuStyleId: "",
        postTypeStyles: [] as PostTypeStyle[],
        channelGroupChannels: [] as ChannelGroupChannel[],
        durationIndicator: false,
        counterIndicator: false,
        durationIndicatorStyleID: null,
        counterIndicatorStyleID: null
    } as ChannelGroup;

    styles: Style[] = [];
    ChannelStyleOptions: ChannelStyle[] = [];
    styleSelected = [] as PostTypeStyle[];

    // used for comparing if form have changes
    priorChannelGroupState = JSON.parse(JSON.stringify(this.channelGroup)) as ChannelGroup;

    nextRoute = "";
    routeParams = {};
    saveClicked = false;
    continue = false;
    fetchingActive = false;
    localId = this.channelGroupId || "";

    // lifecycle hooks
    created() {
        this.fetchData();
        this.initComponents();
    }

    // computed
    get settings(): GroupSettings {
        return this.channelGroup ? {
            name: this.channelGroup.name,
            height: this.channelGroup.height,
            width: this.channelGroup.width,
            behavior: this.channelGroup.behavior || ChannelGroupBehavior.Sorted,
            transitionType: this.channelGroup.transitionType || "none",
            returnToFirstPostTime: this.channelGroup.returnToFirstPostTime || 60,
            showFirstPost: this.channelGroup.showFirstPost || true,
            interactionType: this.channelGroup.interactionType || this.interactionTypes.none,
            transitionTime: this.channelGroup.transitionTime,
            menuStyleId: this.channelGroup.menuStyleId || this.defaultStyle(this.menuStyles),
            durationIndicator: this.channelGroup.durationIndicator || false,
            counterIndicator: this.channelGroup.counterIndicator || false,
            durationIndicatorStyleID: this.channelGroup.durationIndicatorStyleID || this.defaultStyle(this.durationStyles),
            counterIndicatorStyleID: this.channelGroup.counterIndicatorStyleID || this.defaultStyle(this.counterStyles)
        } : {} as GroupSettings;
    }

    get postTypeStyles(): PostTypeStyle[] {
        return this.channelGroup.postTypeStyles ? this.channelGroup.postTypeStyles : [] as PostTypeStyle[];
    }

    get components(): FormComponentModel[] {
        return this.componentsData.sort((x, y) => x.order - y.order);
    }

    get componentsAutoSettingKey(): string {
        let settingsKey = "channelGroupFormComponents";
        settingsKey += this.localId ? "-edit" : "-create";
        return settingsKey;
    }

    get counterStyles() {
        return this.ChannelStyleOptions.filter(x => x.type === ChannelStyleTypes.counter || x.type === ChannelStyleTypes.all);
    }

    get menuStyles() {
        return this.ChannelStyleOptions.filter(x => x.type === ChannelStyleTypes.menuStyle || x.type === ChannelStyleTypes.all);
    }

    get durationStyles() {
        return this.ChannelStyleOptions.filter(x => x.type === ChannelStyleTypes.duration || x.type === ChannelStyleTypes.all);
    }

    defaultStyle(styles: ChannelStyle[]) {
        const stylesFiltered = styles.filter(x => x.id); // Exclude "no style"
        if (stylesFiltered.length > 0 && !this.localId) {
            const defaultStyle = stylesFiltered.filter(x => x.name.toLowerCase().includes("default"))[0];
            if (defaultStyle) return defaultStyle.id;
            else return stylesFiltered[0].id;
        }
        return null;
    }

    // methods

    onBeforeRouteLeave(to: Route, next: any) {
        if (this.saveClicked || this.continue || this.fetchingActive) {
            next();
        } else {
            this.nextRoute = to.name ? to.name : "";
            this.routeParams = to.params;
            this.retrieveData();

            // We have to filter out some properties from channelGroup's channels that cause an "are you sure prompt" to appear.
            // These properties are not something the user control so they are just problematic. Changing order still causes the prompt to appear as it should.
            const filteredChannelGroup: any = JSON.parse(JSON.stringify(this.channelGroup));
            filteredChannelGroup.channelGroupChannels = filteredChannelGroup.channelGroupChannels.map(({ activeDropTarget, active, ...rest }: any) => rest);
            const filteredPriorChannelGroupState: any = JSON.parse(JSON.stringify(this.priorChannelGroupState));
            filteredPriorChannelGroupState.channelGroupChannels = filteredPriorChannelGroupState.channelGroupChannels.map(({ activeDropTarget, active, ...rest }: any) => rest);

            const noChanges = this.lodash.isEqual(filteredPriorChannelGroupState, filteredChannelGroup);
            if (noChanges) {
                next();
            } else {
                next(false);
                (this.$refs.UnsavedFormModal as any).open();
            }
        }
    }

    onContinue(data: boolean) {
        this.continue = data;
        if (data) this.$router.push({ name: this.nextRoute, params: this.routeParams, query: { folder: this.channelGroup.folderId } });
        this.nextRoute = "";
    }

    async save(back: boolean) {
        this.saveClicked = true;
        await this.childComponentsHandler();
        if (!this.formState) {
            this.saveClicked = false;
            return;
        }
        if (!this.localId) {
            this.channelGroup.folderId = this.folderId;
            createChannelGroup(this.channelGroup).then((id: string) => {
                if (back) {
                    this.$router.push({
                        path: `/channelGroups?folder=${this.channelGroup.folderId}`
                    });
                } else {
                    this.localId = id;
                    this.channelGroup.id = id;
                    this.saveClicked = false;
                    this.priorChannelGroupState = JSON.parse(JSON.stringify(this.channelGroup));
                }
            });
            return;
        }
        updateChannelGroup(this.channelGroup).then(() => {
            if (back) {
                this.$router.push({
                    path: `/channelGroups?folder=${this.channelGroup.folderId}`
                });
            }
            this.saveClicked = false;
            this.priorChannelGroupState = JSON.parse(JSON.stringify(this.channelGroup));
        });
    }

    previewChannelGroup() {
        (this.$refs.channelGroupPreviewModal as any).open(this.localId, this.channelGroup.name);
    }

    back() {
        window.history.go(-1);
    }

    async initComponents() {
        let components = getSetting(this.componentsAutoSettingKey);
        if (!components) {
            await setSetting(this.componentsAutoSettingKey,
                [
                    {
                        componentName: "ChannelGroupSettings",
                        sectionName: i18n.t("common.settings"),
                        order: 0,
                        collapseState: true
                    },
                    {
                        componentName: "ChannelGroupChannels",
                        sectionName: i18n.t("channels.title"),
                        order: 1,
                        collapseState: true
                    }]);
            components = getSetting(this.componentsAutoSettingKey);
        }

        this.componentsData = components.map((x: FormComponent) => ({
            componentName: x.componentName,
            order: x.order,
            active: false,
            activeDropTarget: false,
            collapseState: x.collapseState,
            sectionName: x.sectionName
        }));
    }

    async fetchData() {
        this.styles = await getAllStyles();

        this.ChannelStyleOptions = await getAllChannelStyles();
        this.ChannelStyleOptions.sort((a, b) => a.name.localeCompare(b.name, "en"));
        this.ChannelStyleOptions.unshift({ id: null, name: this.$t("channels.noStyle").toString(), type: ChannelStyleTypes.all, css: {} });
        this.priorChannelGroupState.menuStyleId = this.defaultStyle(this.menuStyles);
        this.priorChannelGroupState.durationIndicatorStyleID = this.defaultStyle(this.durationStyles);
        this.priorChannelGroupState.counterIndicatorStyleID = this.defaultStyle(this.counterStyles);

        if (!this.localId) {
            this.channelGroup.transitionType = "fade";
            this.priorChannelGroupState.transitionType = "fade";
            return;
        };

        this.fetchingActive = true;
        this.channelGroup = await getChannelGroupById(this.localId);
        this.channelGroup.channelGroupChannels.forEach(x => { x.selected = true; });
        this.priorChannelGroupState = JSON.parse(JSON.stringify(this.channelGroup));
        this.priorChannelGroupState.channelGroupChannels.forEach((x: any) => { x.order = this.priorChannelGroupState.channelGroupChannels.indexOf(x) + 1; });
        bus.$emit("documentTitle", this.channelGroup.name);
        this.fetchingActive = false;
    }

    // child components events

    onSettingsUpdated(data: any) {
        const settingsComponentData = JSON.parse(data);
        this.channelGroup.name = settingsComponentData.settings.name || "";
        this.channelGroup.width = parseInt(settingsComponentData.settings.width) || 0;
        this.channelGroup.height = parseInt(settingsComponentData.settings.height) || 0;
        this.channelGroup.behavior = settingsComponentData.settings.behavior;
        this.channelGroup.postTypeStyles = settingsComponentData.settings.postTypeStyles;
        this.channelGroup.transitionType = settingsComponentData.settings.transitionType;
        this.channelGroup.interactionType = settingsComponentData.settings.interactionType;
        this.channelGroup.returnToFirstPostTime = settingsComponentData.settings.returnToFirstPostTime;
        this.channelGroup.showFirstPost = settingsComponentData.settings.showFirstPost;
        this.channelGroup.transitionTime = parseFloat(settingsComponentData.settings.transitionTime) || 0;
        this.channelGroup.menuStyleId = settingsComponentData.settings.menuStyleId;
        this.channelGroup.durationIndicator = settingsComponentData.settings.durationIndicator;
        this.channelGroup.counterIndicator = settingsComponentData.settings.counterIndicator;
        this.channelGroup.durationIndicatorStyleID = settingsComponentData.settings.durationIndicatorStyleID;
        this.channelGroup.counterIndicatorStyleID = settingsComponentData.settings.counterIndicatorStyleID;
    }

    onChannelGroupChannelsUpdated(data: any) {
        this.channelGroup.channelGroupChannels = data;
    }

    onComponentStateChanged(componentState: any) {
        const component = this.componentsData.find(x => x.componentName === componentState.name);
        if (!component) return;

        component.collapseState = componentState.state;
        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }

    async childComponentsHandler() {
        const components = this.$refs.childComponent as any[];
        const validators = [] as any[];
        components.forEach(component => {
            if (component.validators) {
                validators.push(component.validators);
            }
            component.emitData();
        });

        this.formState = await validateForm(validators);
    }

    retrieveData() {
        const components = this.$refs.childComponent as any[];
        components.forEach(component => {
            component.emitData();
        });
    }

    // drag & drop event handlers
    drag(event: any) {
        const component = this.componentsData.find(x => x.componentName === event.target.id);
        if (!component) { return; }

        event.dataTransfer.setDragImage((this.$refs[component.componentName] as any)[0], 1000, 0);

        event.dataTransfer.setData(
            "id",
            event.target.id
        );
        component.active = true;
    }

    dragLeave(event: any) {
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        component.activeDropTarget = false;
    }

    dragOver(event: any) {
        event.preventDefault();
        const component = this.componentsData.find(x => x.componentName === event.currentTarget.id);
        if (!component) return;
        const type = event.dataTransfer.types.includes("type");
        if (component.active || type) return;
        component.activeDropTarget = true;
    }

    dragEnd() {
        this.componentsData.forEach(x => {
            x.activeDropTarget = false;
            x.active = false;
        });
    }

    swapComponents(event: any) {
        event.preventDefault();
        if (!event.currentTarget) {
            return;
        }

        const target = this
            .componentsData
            .find(x => event.currentTarget && x.componentName === event.currentTarget.id);
        const source = this
            .componentsData
            .find(x => event.dataTransfer && x.componentName === event.dataTransfer.getData("id"));

        if (!(source && target)) { return; }

        const sourceOrder = source.order;
        source.order = target.order;
        target.order = sourceOrder;

        setSetting(this.componentsAutoSettingKey,
            this.componentsData.map(x => (
                {
                    componentName: x.componentName,
                    order: x.order,
                    collapseState: x.collapseState,
                    sectionName: x.sectionName
                } as FormComponent)));
    }
}
